import { Text } from '~/components/ui/Text';
import { StyledBackground, StyledContainer } from './LoadingScreenNew.styled';

const LoadingScreenNew = ({
	icon,
	text,
	color,
}: {
	icon: string;
	text: string;
	color: string;
}) => {
	return (
		<StyledContainer>
			<StyledBackground style={{ backgroundColor: color }} />
			<img src={icon} />
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { LoadingScreenNew };
